module.exports = __webpack_public_path__ + "img/btn-home-bm.de4f45e0.png";